export default __webpack_public_path__ + "static/media/red-round.641b5204.svg";